import React from "react";
import { Flex, Text, Stack } from "@chakra-ui/react";
import {
  buttonRedText,
  newBorder,
  textPrimary,
  textSecondary,
  white,
} from "../../../utils/colors";
import { useTranslation } from "react-i18next";

const TreatmentPlanSendingPatient = ({ treatmentPlan }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* PATIENT START */}
      <Flex align="center" justify="flex-start" w="100%" m="0 0 1rem">
        <Flex w="100%" direction="column" align="flex-start" justify="center">
          <Text
            fontSize="sm"
            fontWeight="500"
            color={textPrimary}
            m="0 0 0.25rem"
          >
            {t("patient.patient")}:
          </Text>

          <Flex w="100%">
            <Flex
              w="100%"
              border={`1px solid ${newBorder}`}
              borderRadius="10rem"
              p="0.5rem 1rem"
            >
              <Flex align="center">
                <Flex
                  align="center"
                  justify="center"
                  bg={textPrimary}
                  h="2.25rem"
                  w="2.25rem"
                  borderRadius="50%"
                  mr="0.25rem"
                  flexShrink={0}
                >
                  <Text fontSize="xs" color={white} fontWeight="500">
                    {treatmentPlan.patient &&
                      treatmentPlan.patient?.lastName &&
                      treatmentPlan.patient?.lastName[0]}
                    {treatmentPlan.patient &&
                      treatmentPlan.patient?.firstName &&
                      treatmentPlan.patient?.firstName[0]}
                  </Text>
                </Flex>

                <Stack gap={0} w="100%">
                  <Text
                    fontSize="sm"
                    color={textPrimary}
                    fontWeight="500"
                    _groupHover={{
                      color: white,
                    }}
                    maxW="100%"
                    isTruncated
                  >
                    {treatmentPlan.patient &&
                      treatmentPlan.patient.lastName &&
                      treatmentPlan.patient.lastName}{" "}
                    {treatmentPlan.patient &&
                      treatmentPlan.patient.firstName &&
                      treatmentPlan.patient.firstName}
                  </Text>

                  {treatmentPlan.patient && treatmentPlan.patient.email ? (
                    <Text
                      fontSize="0.8rem"
                      color={textSecondary}
                      fontWeight="500"
                      maxW="100%"
                      isTruncated
                    >
                      {treatmentPlan.patient &&
                        treatmentPlan.patient.email &&
                        treatmentPlan.patient.email}
                    </Text>
                  ) : (
                    <Text
                      fontSize="0.8rem"
                      color={buttonRedText}
                      fontWeight="500"
                      maxW="100%"
                      isTruncated
                    >
                      {t("patient.noEmail")}
                    </Text>
                  )}
                </Stack>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      {/* PATIENT END */}
    </>
  );
};

export default TreatmentPlanSendingPatient;
